import _ from "lodash";
import PropTypes from "prop-types";
import { useState, useContext, useEffect } from "react";
import { ThemeProvider, useMediaQuery } from "@mui/material";
import { Box, Paper } from "@mui/material";
import Paginator from "../../toolkit/Paginator";
import PageTitleBar from "../PageTitleBar";
import LoadingSpinner from "../../toolkit/LoadingSpinner";
import ErrorAlert from "../../toolkit/ErrorAlert";
import baseTheme from "../../themes/baseTheme";

import ResultsListView from "./ResultsListView";
import ResultsGridView from "./ResultsGridView";
import SlidingPopup from "../SlidingPopup";
import FormControl from "../FormControl";
import "../../Localization/i18n";
import { useTranslation } from "react-i18next";
import theme from "../../themes/baseTheme";
import "../../styles/Collections.css";
import Delayed from "../../utils/Delayed";
import { UsersContext } from "../../store/users-context";
import ResultListOrderable from "./ResultsListOrderable";

export default function CollectionsTemplate({
  title,
  TitlebarChildren,
  page,
  setPage,
  pageCount,
  fetchState,
  collection,
  viewType,
  RecCount,
  // queryUrl,
  // defaultParam,
  // searchPlaceholder = "Search",
  //responseDataAdaptor,
  ListItemComponent,
  GridItemComponent,
  SlidingPopupTitle,
  SlidingPopupContent,
  ClosePopUp,
  // noOfPages:noOfPages,
  // refresh,
  //isListView,
  // search: searchvalueHandler,
  CollectionControls,
  isReodering,
  reOrderedData,
  setTrg,
  Trg
}) {
  const { t } = useTranslation();
  // const [queryParams, setQueryParams] = useSearchParams();
  // const [state, setDataState] = useReducer(stateReducer, {
  //   status: "loading",
  //   error: undefined,
  //   results: undefined,
  // });
  // const [count,setCount]=useState();
  const usersContext = useContext(UsersContext);

  const largeScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const [showSlidingPopup, setShowSlidingPopup] = useState(false);
  //const [viewType, setViewType] = useState(isListView?"list":"grid");

  function openSlidingPopup() {
    setShowSlidingPopup(true);
    if (usersContext) usersContext.setFilterIsOpened(true); //global
  }
  function closeSlidingPopup() {
    setShowSlidingPopup(false);
    if (usersContext) usersContext.setFilterIsOpened(false); //global
  }
  useEffect(() => {
    if (usersContext?.filterIsOpened === false) closeSlidingPopup();
    if (ClosePopUp == true) closeSlidingPopup();
  }, [usersContext?.filterIsOpened, ClosePopUp]);

  return (
    <ThemeProvider theme={baseTheme}>
      <Box>
        <PageTitleBar title={title}>
          <TitlebarChildren />
        </PageTitleBar>
        <Paper
          elevation={0}
          variant="outlined"
          sx={{ backgroundColor: baseTheme.palette.grey[20] }}
        >
          {CollectionControls && (
            <CollectionControls
              openSlidingPopup={openSlidingPopup}
              largeScreen={largeScreen}
            />
          )}
          <Box>
            {fetchState.loading ? (
              <LoadingSpinner /> // ToDo:-  Removed message={fetchState.loading}
            ) : fetchState.error && fetchState.error !== 'URL not specified' ? (
              <ErrorAlert message={"Error fetching information"} />
            ) : collection?.rows?.length === 0 ? (
              <Delayed>
                <ErrorAlert severity="warning" message={"No results found!"} />
              </Delayed>
            ) : !largeScreen || viewType === "grid" ? (
              <ResultsGridView {...collection} GridItem={GridItemComponent} />
            ) : (
              <>
                {isReodering ? (
                  <ResultListOrderable
                    {...collection}
                    setTrg={setTrg}
                    Trg={Trg}
                    ListItem={ListItemComponent}
                    reOrderedData={reOrderedData}
                  />
                ) : (
                  <ResultsListView
                    setTrg={setTrg}
                    Trg={Trg}
                    {...collection}
                    ListItem={ListItemComponent}
                  />
                )}
              </>
            )}
          </Box>
        </Paper>
      </Box>
      {!fetchState.loading &&
        !fetchState.error &&
        collection?.rows?.length > 0 && (
          <>
            <Paginator
              count={pageCount}
              page={Number(page)}
              margin="18px 0px"
              onChange={setPage}
            />
            {/* {RecCount} */}
          </>
        )}
      {SlidingPopupContent && (
        <SlidingPopup
          title={SlidingPopupTitle}
          anchor={"right"}
          open={showSlidingPopup}
          //ClosePopUp={ClosePopUp}
          closeSlidingPopup={closeSlidingPopup}
        >
          {SlidingPopupContent}
        </SlidingPopup>
      )}
    </ThemeProvider>
  );
}

CollectionsTemplate.propTypes = {
  /**
   * Component that will be shown at the top right of the page
   */
  TitlebarChildren: PropTypes.func,
  /**
   * Component that contains the collection controls, like search input, client selector, filters button
   */
  CollectionControls: PropTypes.func,
  /**
   * Component that will be used in the Grid view
   */
  GridItemComponent: PropTypes.func,
  /**
   * Component that will be used in the list view
   */
  ListItemComponent: PropTypes.func,
  /**
   * The page number that is being shown - will be highlighted in the paginator
   */
  page: PropTypes.number,
  /**
   * The state of the axios fetch - loading or error or success
   */
  fetchState: PropTypes.object,
  /**
   * The collection that is being displayed.
   */
  collection: PropTypes.object,
  /**
   * list or grid
   */
  viewType: PropTypes.string,
};

CollectionsTemplate.defaultProps = {
  fetchState: { loading: "Loading collection" },
  page: 1,
  setPage: () => { },
};
